import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import getCsrfToken from "../utils/csrf";

export default class extends Controller {
  static values = { deleteUrl: String };

  async paginate(event) {
    const link = event.target.closest("a");
    if (!link || !event.currentTarget.contains(link)) return;

    event.preventDefault();
    event.stopPropagation();

    const href = link.getAttribute("href");
    if (!href || href === "#" || href === "javascript:void(0)" || link.classList.contains("disabled")) return;

    const url = link.href;
    if (!url) return;

    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
      });

      if (!response.ok) return;

      const html = await response.text();
      const wrapper = document.createElement("div");
      wrapper.innerHTML = html;

      const incomingRegion = wrapper.querySelector('[data-batch-import-preview-region="listings"]');
      const currentRegion = this.element.querySelector('[data-batch-import-preview-region="listings"]');

      if (!incomingRegion || !currentRegion) return;

      // Keep the existing region node to preserve layout and scrolling behavior in the modal.
      currentRegion.innerHTML = incomingRegion.innerHTML;
    } catch (_err) {
      // Keep modal state unchanged on network/parsing errors.
    }
  }

  async deleteFile(event) {
    event.preventDefault();

    if (!window.confirm(event.currentTarget.dataset.confirmQuestion)) return;

    const response = await fetch(this.deleteUrlValue, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        Accept: "application/json",
      },
    });

    if (response.ok) {
      window.location.reload();
    }
  }

  async submitApproval(event) {
    event.preventDefault();

    const form = event.target;
    const url = form.action;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        Accept: "text/html",
      },
    });

    if (!response.ok) return;

    const html = await response.text();

    // Hide preview modal
    $("#modal__batch-import-preview").modal("hide");

    // Inject success modal and show it
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;
    document.body.appendChild(wrapper.firstElementChild);
    $("#modal__import-started").modal("show");
  }
}
